import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { BRAND } from '@maintenance-tracker/shared';
import { BrandLogo } from '@/components/brand/brand-logo';
import {
  LEGAL_LAST_UPDATED,
  LegalNav,
  TermsContent,
  PrivacyContent,
  RefundsContent,
  CookiesContent,
  AcceptableUseContent,
  DisclaimerContent,
  SubprocessorsContent,
  SecurityContent,
  SmsTermsContent,
  DpaContent,
  AccessibilityContent,
  DataRequestsContent,
} from '@/pages/legal-content';

export function LegalLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-bg-app pb-24">
      <header className="border-b border-border bg-bg-surface px-4 py-4">
        <div className="mx-auto flex max-w-3xl items-center justify-between gap-4">
          <BrandLogo size="sm" to="/" />
          <span className="text-xs text-text-muted">Effective {LEGAL_LAST_UPDATED}</span>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-12">
        <article className="legal-prose max-w-none">
          <h1>{title}</h1>
          {children}
        </article>
        <LegalNav />
      </main>
    </div>
  );
}

export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service">
      <TermsContent />
    </LegalLayout>
  );
}

export function PrivacyPage() {
  return (
    <LegalLayout title="Privacy Policy">
      <PrivacyContent />
    </LegalLayout>
  );
}

export function RefundsPage() {
  return (
    <LegalLayout title="Refund & Cancellation Policy">
      <RefundsContent />
    </LegalLayout>
  );
}

export function CookiesPage() {
  return (
    <LegalLayout title="Cookie Policy">
      <CookiesContent />
    </LegalLayout>
  );
}

export function AcceptableUsePage() {
  return (
    <LegalLayout title="Acceptable Use Policy">
      <AcceptableUseContent />
    </LegalLayout>
  );
}

export function DisclaimerPage() {
  return (
    <LegalLayout title="Disclaimer">
      <DisclaimerContent />
    </LegalLayout>
  );
}

export function SubprocessorsPage() {
  return (
    <LegalLayout title="Subprocessors">
      <SubprocessorsContent />
    </LegalLayout>
  );
}

export function SecurityPage() {
  return (
    <LegalLayout title="Security Overview">
      <SecurityContent />
    </LegalLayout>
  );
}

export function SmsTermsPage() {
  return (
    <LegalLayout title="SMS & Messaging Terms">
      <SmsTermsContent />
    </LegalLayout>
  );
}

export function DpaPage() {
  return (
    <LegalLayout title="Data Processing Addendum">
      <DpaContent />
    </LegalLayout>
  );
}

export function AccessibilityPage() {
  return (
    <LegalLayout title="Accessibility Statement">
      <AccessibilityContent />
    </LegalLayout>
  );
}

export function DataRequestsPage() {
  return (
    <LegalLayout title="Data Subject Requests">
      <DataRequestsContent />
    </LegalLayout>
  );
}
